import { ReactNode } from "react";
import { ToastType } from "../../interfaces/Toast";
import { IconAtom } from "../icon";
import styles from "./styles.module.scss";

interface Props {
  children?: ReactNode;
  onClose?: () => void;
  type?: ToastType;
}

export function BannerStrokeAtom({ children, onClose, type = "error" }: Readonly<Props>) {
  const typeClass = styles[`stroke--${type}`];
  return (
    <div className={`${styles.stroke} ${typeClass}`}>
      <div className={styles.stroke__content}>{children}</div>
      {onClose && (
        <button type={"button"} className={styles.stroke__close} aria-label={"Melding sluiten"} onClick={onClose}>
          <IconAtom icon={"icon-close"} size={"small"} alt={""} />
        </button>
      )}
    </div>
  );
}
